import React, { useEffect, useState } from 'react';
import {
  Platform,
  ScrollView, StyleSheet, Text, View,
} from 'react-native';
import TicketGroupTag from './TicketGroupTag';
import updateTicketUserGroups from '../../../requests/Tickets/UpdateTicketUserGroups';
import { UserGroup } from '../../../constants/Types';
import Colors from '../../../constants/Colors';
import Style from '../../../constants/Style';
import PressableStyled from '../../../components/PressableStyled';
import PlusIcon from '../../../components/16pxIcons/PlusIcon';
import AddGroupList from '../../../components/AssetManagement/AddTemplateModal/components/IssueList/components/IssueRow/components/AddGroupList';

interface TicketUserGroupsProps {
  ticketId: string,
  userGroups: UserGroup[],
  ticketUserGroupIds: string[],
  // eslint-disable-next-line no-unused-vars
  setSavingTicketUserGroups: (saving: boolean) => void,
}

const TicketUserGroups = ({
  ticketId, userGroups, ticketUserGroupIds, setSavingTicketUserGroups,
}: TicketUserGroupsProps) => {
  const [showAddTagList, setShowAddTagList] = useState<boolean>(false);
  const [tags, setTags] = useState<string[]>(ticketUserGroupIds ?? []);

  useEffect(() => {
    setTags(ticketUserGroupIds ?? []);
  }, [ticketUserGroupIds]);

  const updateTags = (updatedTags: string[]) => {
    setSavingTicketUserGroups(true);
    updateTicketUserGroups(ticketId, updatedTags).then(() => {
      setTags(updatedTags);
      setShowAddTagList(false);
      setSavingTicketUserGroups(false);
    });
  };

  return <View style={{
    flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'flex-end', gap: 6,
  }}>
    {tags.length > 0 && <>
      {tags.filter((tag) => !!tag).map((groupId: string, index: number) => (
        <TicketGroupTag
          key={`${groupId}-${index}`}
          groupId={groupId}
          userGroups={userGroups}
          deleteAction={tags?.length > 1 ? () => {
            updateTags((tags ?? []).filter((id: string) => id !== groupId));
          } : null}
          tags={tags}
          itemIndex={index}
          addGroup={updateTags}
        />
      ))}
    </>}
    <View>
      <PressableStyled
        style={[Style.row, {
          borderWidth: 1,
          borderColor: Colors.light.hereworksDarkBlue,
          borderRadius: 6,
          paddingHorizontal: 6,
          paddingVertical: 4,
          zIndex: -1,
        }]}
        onPress={() => setShowAddTagList(!showAddTagList)}>
        <Text style={styles.addUserGroupTitle}>{showAddTagList ? 'Cancel add' : 'Add user group'}</Text>
        <PlusIcon color={Colors.light.hereworksDarkBlue} />
      </PressableStyled>
      {showAddTagList && <ScrollView
        style={styles.tagDropdown}
        nestedScrollEnabled
      >
        <AddGroupList
          {...{ tags }}
          update={(userGroupId: string) => {
            updateTags([...(tags ?? []), userGroupId]);
          }}
          groups={userGroups}
        />
      </ScrollView>}
    </ View>
  </View>;
};

export default TicketUserGroups;

const styles = StyleSheet.create({
  addUserGroupTitle: {
    color: Colors.light.hereworksDarkBlue,
    fontSize: 12,
    fontFamily: 'Roboto_400Regular',
    marginRight: 6,
  },
  tagDropdown: {
    position: Platform.OS === 'android' ? undefined : 'absolute',
    right: 0,
    top: Platform.OS === 'android' ? undefined : 38,
    marginTop: 4,
    maxHeight: 180,
    alignSelf: 'flex-start',
    zIndex: 20,
    backgroundColor: Colors.light.plainBackground,
    borderWidth: 1,
    borderColor: Colors.light.hereworksDarkBlue,
    borderRadius: 6,
  },
});
